import toastr from "toastr";

const Toaster = toastr;

Toaster.options = {
  timeOut: 15000
};

export default Toaster;
